import React from "react";
import { useNavigate } from "react-router-dom";
import { CButton, CContainer } from "@coreui/react-pro";
import PublicContentPageShell from "../../components/public/PublicContentPageShell";
import "../../styles/public-experience.css";
import "../../styles/public-family-alignment.css";

const MnuSuccess = () => {
  const navigate = useNavigate();

  const hero = (
    <section className="public-info-hero">
      <CContainer fluid className="public-core-container public-page-shell public-info-shell">
        <div className="public-info-hero__panel public-page-hero-panel">
          <div className="public-info-hero__copy">
            <span className="public-core-eyebrow public-page-overline">Erfolg</span>
            <h1 className="public-page-title">Erfolg entsteht aus nachvollziehbaren nächsten Schritten</h1>
            <p className="public-page-body public-info-hero__lead">
              Experts4Europe macht Fortschritt sichtbar, ohne ihn künstlich aufzublasen:
              gute Vorbereitung, stärkere Unterlagen und klarere Chancen greifen sichtbar ineinander.
            </p>
            <div className="public-legal-chip-row">
              <span>Sichtbarkeit</span>
              <span>Bewerbung</span>
              <span>Chancen</span>
            </div>
          </div>
          <aside className="public-info-hero__meta">
            <div className="public-page-callout public-info-callout">
              <strong>Was zählt</strong>
              <span>Klare Nachweise, gute Vorbereitung und belastbare nächste Schritte statt lauter Erfolgsversprechen.</span>
            </div>
            <div className="public-page-callout public-info-callout">
              <strong>Wie es lesbar wird</strong>
              <span>Fortschritt bleibt über Arbeitsräume, Orientierung und öffentliche Chancen nachvollziehbar.</span>
            </div>
          </aside>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicContentPageShell pageClassName="public-info-page" hero={hero}>
      <section className="public-core-band public-core-band--light">
        <CContainer fluid className="public-core-container public-page-shell public-info-shell">
          <div className="public-info-stack">
            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Was Erfolg hier bedeutet</span>
              <div className="public-info-list">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Mehr Sichtbarkeit</h2>
                  <p className="public-page-body">Dein Profil wird für passende Arbeitgeber besser lesbar und leichter auffindbar.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Bessere Bewerbung</h2>
                  <p className="public-page-body">CV, Skills, Referenzen und Sprache ergeben gemeinsam ein stärkeres Gesamtbild.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Klare Chancen</h2>
                  <p className="public-page-body">Du siehst passende Stellen und den nächsten sinnvollen Schritt statt einer unruhigen Jobmasse.</p>
                </div>
              </div>
            </article>

            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Wie Experts4Europe unterstützt</span>
              <div className="public-info-list public-info-list--compact">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Mission Control</h2>
                  <p className="public-page-body">Die öffentliche Startseite und die Arbeitsräume führen Orientierung, Fortschritt und Anschlussmöglichkeiten zusammen.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Fokussierte Arbeitsräume</h2>
                  <p className="public-page-body">Bewerbung, Sprache und Vorbereitung bleiben klar getrennt, aber in derselben Produktfamilie verbunden.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Öffentliche Chancen</h2>
                  <p className="public-page-body">Die Stellenbörse ergänzt diesen Pfad sichtbar, ohne wie eine eigene Fremdseite zu wirken.</p>
                </div>
              </div>
            </article>

            <div className="public-info-actions public-page-card">
              <div className="public-info-actions__copy">
                <span className="public-core-eyebrow public-page-overline">Nächster Schritt</span>
                <h2 className="public-page-subtitle">Direkt in Orientierung oder Chancen weitergehen</h2>
              </div>
              <div className="public-info-actions__buttons">
                <CButton type="button" className="public-core-btn public-core-btn--primary" onClick={() => navigate("/stb/job-marketplace")}>
                  Stellenbörse öffnen
                </CButton>
                <CButton type="button" className="public-core-btn public-core-btn--subtle" onClick={() => navigate("/applicant/frontdoor?entry=abroad")}>
                  Quick Check starten
                </CButton>
              </div>
            </div>
          </div>
        </CContainer>
      </section>
    </PublicContentPageShell>
  );
};

export default MnuSuccess;
